import React from 'react';
import { UtpCardSection } from 'common/components';
import { INTERIOR_DOORS_ELEMENT_BLOCK } from '../../interior-doors-constants';
import { INTERIOR_DOORS_UTP_CARD_LIST } from './interior-doors-utp-card-section-constants';

type InteriorDoorsUtpCardSectionProps = {
  onConsultationSignupBtnClick: () => void;
};

export const InteriorDoorsUtpCardSection = ({
  onConsultationSignupBtnClick,
}: InteriorDoorsUtpCardSectionProps) => (
  <UtpCardSection
    elementBlock={INTERIOR_DOORS_ELEMENT_BLOCK}
    elementText="Межкомнатные двери в Лемана ПРО"
    renderModalContent={({ modal: { content: ModalContent } = {} }, onCloseModal) => (
      ModalContent && <ModalContent
        onConsultationSignupBtnClick={() => {
          onCloseModal();
          onConsultationSignupBtnClick();
        }}
      />
    )}
    title="Закажите межкомнатные двери в&nbsp;Лемана&nbsp;ПРО"
    utpCardList={INTERIOR_DOORS_UTP_CARD_LIST}
  />
);
